export default __webpack_public_path__ + "0587f9be8e442eb74b2fe283bbf1a947.png";